import React from 'react'
import { I18n } from '@front/volcanion/'

import { Typography, Grid, Box, StepLabel, StepContent, Button, Icon } from '@mui/material'
import { TextField, MenuSelectorField, SingleOptionSelectorField, ModelMenuSelectorField } from '@front/squirtle'

import CPUtils from '@front/squirtle/utils/CPUtils'

const Row1 = ({ isManagingRecord, statusColor, statusChange }) =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <MenuSelectorField
        label={I18n.t('status.label', { count: 1 })}
        name={'status'}
        options={_.compact([
          { label: I18n.t('status.active'), value: 'active' },
          { label: I18n.t('status.deleted'), value: 'deleted', disabled: !isManagingRecord },
          { label: I18n.t('status.suspended'), value: 'suspended', disabled: !isManagingRecord }
        ])}
        valueDecoratorProps={{
          sx: { WebkitTextFillColor: statusColor, fontWeight: 600 }
        }}
        selectFirst
        required
        afterChange={statusChange}
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name={'contact.email'}
        label={I18n.t('email.label.pro')}
        emptyValue='-'
        required
      />
    </Grid>
    <Grid size="grow">
      <MenuSelectorField
        label={I18n.t('admin', { count: 1 })}
        noneLabel={I18n.t('prefix.no')}
        name={'administration_level'}
        options={[
          { label: I18n.t('company.label', { count: 1 }), value: 'company' },
          { label: I18n.t('contract.label', { count: 1 }), value: 'contract' },
          { label: I18n.t('companyservice.label', { count: 1 }), value: 'service' },
        ]}
      />
    </Grid>
  </Grid >

const Row2 = ({ displayIdentifierPin, onResetIdentifier, isManagingRecord }) => (
  <Grid container size={12}>
    <Grid hidden={!isManagingRecord || !displayIdentifierPin} size="grow">
      <TextField
        name={'identifier'}
        label={I18n.t('identifier.label', { count: 1 })}
        disabled
      />
    </Grid >
    <Grid hidden={!isManagingRecord || !displayIdentifierPin} size="grow">
      <TextField
        name={'pin'}
        label={I18n.t('pin.label', { count: 1 })}
        disabled
      />
    </Grid>
    <Grid
      alignItems='flex-end'
      hidden={!isManagingRecord || !displayIdentifierPin}
      size="grow">
      <Button variant='text' color='primary' startIcon={<Icon size={8}>{'lock_reset'}</Icon>} onClick={onResetIdentifier} sx={{ textTransform: 'none' }}>
        <Typography color='primary'>{I18n.t('identifier.generate')}</Typography>
      </Button>
    </Grid>
  </Grid>
)

const Row3 = () =>
  <Grid container spacing={1} size={12}>
    <Grid size={12}>
      <Typography sx={{ fontSize: 'subtitle.fontSize', color: 'primary.main' }}>{I18n.t('order.can_book_for')}:</Typography>
    </Grid>
    <Grid size={2}>
      <SingleOptionSelectorField name={'self_booking'} optionLabel={I18n.t('companyuser.booking.self')} clearOnEmpty={false} />
    </Grid>
    <Grid size={2}>
      <SingleOptionSelectorField name={'guest_booking'} optionLabel={I18n.t('companyuser.booking.guest')} clearOnEmpty={false} />
    </Grid>
    <Grid size={4}>
      <MenuSelectorField
        name='booking_level'
        label={I18n.t("companyuser.booking.company")}
        options={[
          { label: I18n.t('company.label', { count: 1 }), value: 'company' },
          { label: I18n.t('contract.label', { count: 1 }), value: 'contract' },
          { label: I18n.t('companyservice.label', { count: 1 }), value: 'service' },
        ]}
      />
    </Grid>
    <Grid size={4}>
      <ModelMenuSelectorField
        name='blacklisted_domains'
        label={I18n.t('domain.blacklist', { count: 1 })}
        model_name='domain'
        labelKeys={['name']}
        searchMode={'search'}
        loadOnMount
        multiple
        config={{
          forced_filter: { user_type: 'booker' }
        }}
      />
    </Grid>
  </Grid>

const Row4 = () => (
  <Grid container spacing={1} size={12}>
    <Grid size={12}>
      <ModelMenuSelectorField
        name='exluded_commercial_packages'
        model_name='commercialpackage'
        label={I18n.t('commercialpackage.label.exclude')}
        searchMode='search'
        multiple
        config={{
          initial_filter: { load_type: 'user' },
          forced_filter: { load_type: 'user' },
          mutator: cp => ({ ...CPUtils.getTranslatedLabel(cp), ...cp })
        }}
      />
    </Grid>
  </Grid>
)

const SpecialRuleSection = props => (
  <>
    <StepLabel>
      <Typography variant='h5'> {I18n.t('info.company')}</Typography>
    </StepLabel>
    <StepContent>
      <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
        <Grid container rowSpacing={2}>
          <Row1 {...props} />
          <Row2 {...props} />
          <Row3 />
          <Row4 />
        </Grid>
      </Box>
    </StepContent>
  </>
)

export default React.memo(SpecialRuleSection)
